"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpsertUserNotificationPreferences = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const lodash_es_1 = require("lodash-es");
const getNotificationPreferences_1 = require("../../../features/NotificationsSettings/api/getNotificationPreferences");
const translations_1 = require("../../../features/NotificationsSettings/types/translations");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const useUpsertUserNotificationPreferencesAPI = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return (body) => {
        const url = `${config.NOTIFICATION_CENTER_ENDPOINT}/user-notification-preferences/current`;
        return fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then((r) => {
            return r.json();
        })
            .catch((e) => {
            throw Error(e?.message);
        });
    };
};
const useUpsertUserNotificationPreferences = () => {
    const upsertUserNotificationPreferencesAPI = useUpsertUserNotificationPreferencesAPI();
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const { logError, logInfo } = (0, LoggerContext_1.useLoggerContext)();
    return (0, frontend_infra_reactquery_1.useMutation)({
        mutationKey: ['updateNotificationPreferences'],
        mutationFn: upsertUserNotificationPreferencesAPI,
        onMutate: async (body) => {
            await queryClient.cancelQueries({ queryKey: [getNotificationPreferences_1.NOTIFICATION_PREFERENCES_KEY] });
            const previousValue = queryClient.getQueryData([getNotificationPreferences_1.NOTIFICATION_PREFERENCES_KEY]);
            queryClient.setQueryData([getNotificationPreferences_1.NOTIFICATION_PREFERENCES_KEY], (old) => {
                return {
                    ...old,
                    preferences: (0, lodash_es_1.unionBy)(body.preferences, old?.preferences || [], 'reference'),
                };
            });
            return { previousValue };
        },
        onSuccess: async (data) => {
            logInfo('Preference Update Success');
            queryClient.setQueryData([getNotificationPreferences_1.NOTIFICATION_PREFERENCES_KEY], data);
        },
        onError: (_err, _body, context) => {
            logError('Preference Update Failed');
            snackService.showError(translate(translations_1.preferenceErrorTranslations.upsertError));
            if (context?.previousValue)
                queryClient.setQueryData([getNotificationPreferences_1.NOTIFICATION_PREFERENCES_KEY], context.previousValue);
        },
    });
};
exports.useUpsertUserNotificationPreferences = useUpsertUserNotificationPreferences;
//# sourceMappingURL=upsertUserNotificationPreferences.js.map